import type { AutoFixProvider } from '@/lib/ai-review-settings/schema';

import { resolveAutoFixProviderActionLabel } from '@/lib/ai-review-settings/auto-fix-provider-action-labels';
import { resolveFixAllProviderCopy } from '@/lib/ai/code-review-service/utils/review-additional-messages/message-rules/fix-all-provider-copy';

export type FixProviderButtonCopy = {
  fixWithLabel: string;
  fixWithRequiresProAriaLabel: string;
  fixOutstandingLabel: string;
  /** The comments popover's fix button, worded like the review footer's "Fix all" link. */
  fixAllLabel: string;
  fixAllRequiresProAriaLabel: string;
  noActionableSessionLabel: string;
  buildFixLatestLabel: (pluralizedComments: string) => string;
};

function resolveFixAllButtonCopy(
  provider: AutoFixProvider,
): Pick<FixProviderButtonCopy, 'fixAllLabel' | 'fixAllRequiresProAriaLabel'> {
  const { footerLinkLabel } = resolveFixAllProviderCopy(provider);
  return {
    fixAllLabel: footerLinkLabel,
    fixAllRequiresProAriaLabel: `${footerLinkLabel} requires Pro`,
  };
}

const FIX_PROVIDER_BUTTON_COPY: Record<AutoFixProvider, FixProviderButtonCopy> = {
  cubic: {
    fixWithLabel: resolveAutoFixProviderActionLabel('cubic'),
    fixWithRequiresProAriaLabel: 'Fix with cubic requires Pro',
    fixOutstandingLabel: 'Fix outstanding comments with cubic',
    ...resolveFixAllButtonCopy('cubic'),
    noActionableSessionLabel: 'No actionable cubic fix session available',
    buildFixLatestLabel: (pluralizedComments) => `Fix the latest ${pluralizedComments} with cubic`,
  },
  cursor_cloud_agent: {
    fixWithLabel: resolveAutoFixProviderActionLabel('cursor_cloud_agent'),
    fixWithRequiresProAriaLabel: 'Fix with Cursor requires Pro',
    fixOutstandingLabel: 'Fix outstanding comments with Cursor',
    ...resolveFixAllButtonCopy('cursor_cloud_agent'),
    noActionableSessionLabel: 'No actionable Cursor fix session available',
    buildFixLatestLabel: (pluralizedComments) => `Fix the latest ${pluralizedComments} with Cursor`,
  },
};

export function resolveFixProviderButtonCopy(provider: AutoFixProvider): FixProviderButtonCopy {
  return FIX_PROVIDER_BUTTON_COPY[provider];
}
